export default "__VITE_ASSET__CY5vrd$z__"